/* 786 sections: shade wall colors + filters, tabs underline, carousel drag, add-to-cart, wishlist, floating collage */
(function () {
  'use strict';
  var g = window.gsap;
  var shadeMapPromise = null;

  function loadShadeMap() {
    if (shadeMapPromise) return shadeMapPromise;
    var url = window.S786 && window.S786.shadeJson;
    shadeMapPromise = url ? fetch(url).then(function (r) { return r.json(); }).catch(function () { return {}; }) : Promise.resolve({});
    return shadeMapPromise;
  }

  // Fallback: dominant colour from image via canvas (Shopify CDN sends CORS headers)
  function colorFromImage(src) {
    return new Promise(function (resolve) {
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'), s = 40; c.width = s; c.height = s;
          var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, s, s);
          var d = ctx.getImageData(0, 0, s, s).data, bins = {}, best = null;
          for (var i = 0; i < d.length; i += 4) {
            var r = d[i], gg = d[i + 1], b = d[i + 2], a = d[i + 3]; if (a < 200) continue;
            var mx = Math.max(r, gg, b), mn = Math.min(r, gg, b), l = (mx + mn) / 510, sat = mx ? (mx - mn) / mx : 0;
            if (l > 0.93 || l < 0.08 || (sat < 0.12 && l > 0.5)) continue;
            var k = (r >> 4) + ',' + (gg >> 4) + ',' + (b >> 4);
            var o = bins[k] = bins[k] || { n: 0, r: 0, g: 0, b: 0 }; o.n++; o.r += r; o.g += gg; o.b += b;
            if (!best || o.n > best.n) best = o;
          }
          resolve(best ? 'rgb(' + Math.round(best.r / best.n) + ',' + Math.round(best.g / best.n) + ',' + Math.round(best.b / best.n) + ')' : null);
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  /* ---------------- Shade wall ---------------- */
  function shadeWall(root) {
    var wall = root.querySelector('[data-shade-wall]'); if (!wall) return;
    var swatches = wall.querySelectorAll('.s786-swatch[data-handle]');
    // hide trailing swatches so the wall always ends on a full row
    var grid = wall.querySelector('.s786-shades__wall');
    function fullRows() {
      var all = grid.querySelectorAll('.s786-swatch'); if (!all.length) return;
      var cols = Math.max(1, Math.round(grid.offsetWidth / all[0].offsetWidth));
      var keep = Math.floor(all.length / cols) * cols; if (keep < cols * 2) keep = all.length;
      all.forEach(function (s, i) { s.style.display = i < keep ? '' : 'none'; });
    }
    fullRows(); window.addEventListener('resize', fullRows);
    loadShadeMap().then(function (map) {
      swatches.forEach(function (sw) {
        if (sw.dataset.hex) return;
        var hex = map[sw.dataset.handle];
        if (hex) { sw.style.setProperty('--sw', hex); sw.dataset.hex = hex; }
        else if (sw.dataset.img) colorFromImage(sw.dataset.img).then(function (c) { if (c) sw.style.setProperty('--sw', c); });
      });
    });

    // tooltip
    var tip = wall.querySelector('[data-shade-tip]');
    if (tip && window.matchMedia('(hover: hover)').matches) {
      var tImg = tip.querySelector('[data-tip-img]'), tName = tip.querySelector('[data-tip-name]'), tPrice = tip.querySelector('[data-tip-price]');
      wall.addEventListener('mouseover', function (e) {
        var sw = e.target.closest('.s786-swatch[data-handle]'); if (!sw) return;
        tImg.src = sw.dataset.img; tName.textContent = sw.dataset.title; tPrice.textContent = sw.dataset.price;
        tip.classList.add('is-on');
      });
      wall.addEventListener('mousemove', function (e) {
        if (!e.target.closest('.s786-swatch[data-handle]')) return;
        tip.style.left = e.clientX + 'px'; tip.style.top = (e.clientY - 96) + 'px';
      });
      wall.addEventListener('mouseleave', function () { tip.classList.remove('is-on'); });
      wall.addEventListener('mouseout', function (e) { if (!e.relatedTarget || !e.relatedTarget.closest('.s786-swatch')) tip.classList.remove('is-on'); });
    }

    // ripple: neighbours lift on hover
    if (grid && window.matchMedia('(hover: hover)').matches) {
      grid.addEventListener('mouseover', function (e) {
        var sw = e.target.closest('.s786-swatch'); if (!sw) return;
        var all = Array.prototype.slice.call(grid.querySelectorAll('.s786-swatch')), i = all.indexOf(sw), cols = Math.max(1, Math.round(grid.offsetWidth / sw.offsetWidth));
        all.forEach(function (x) { x.classList.remove('is-near'); });
        [i - 1, i + 1, i - cols, i + cols].forEach(function (j) { if (all[j] && Math.abs((j % cols) - (i % cols)) <= 1) all[j].classList.add('is-near'); });
      });
      grid.addEventListener('mouseleave', function () { grid.querySelectorAll('.is-near').forEach(function (x) { x.classList.remove('is-near'); }); });
    }
    // tab filtering
    var tabs = wall.querySelectorAll('[data-tabs] [data-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active');
        var tags = (t.dataset.tags || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        var all = t.dataset.tab === 'all';
        var shown = [];
        swatches.forEach(function (sw) {
          var mine = (sw.dataset.tags || '').split(',');
          var ok = all || tags.some(function (tg) { return mine.indexOf(tg) > -1; });
          sw.classList.toggle('is-dim', !ok); if (ok) shown.push(sw);
        });
        if (g) g.fromTo(shown, { scale: 0.7 }, { scale: 1, duration: 0.6, ease: 'back.out(2)', stagger: { each: 0.01, from: 'random' } });
        moveTabLine(t);
      });
    });
  }

  /* ---------------- Tabs underline ---------------- */
  function moveTabLine(item) {
    var nav = item.closest('[data-tabs]'), line = nav && nav.querySelector('.s786-tabs__line'); if (!line) return;
    line.style.width = item.offsetWidth + 'px'; line.style.transform = 'translateX(' + item.offsetLeft + 'px)';
  }
  function tabs(root) {
    root.querySelectorAll('[data-tabs]').forEach(function (nav) {
      var act = nav.querySelector('.is-active'); if (act) moveTabLine(act);
      nav.addEventListener('mouseover', function (e) { var i = e.target.closest('.s786-tabs__item'); if (i) moveTabLine(i); });
      nav.addEventListener('mouseleave', function () { var a = nav.querySelector('.is-active'); if (a) moveTabLine(a); });
    });
    window.addEventListener('resize', function () { root.querySelectorAll('[data-tabs] .is-active').forEach(moveTabLine); });
  }

  /* ---------------- Carousel ---------------- */
  function carousel(root) {
    root.querySelectorAll('[data-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-carousel-track]'); if (!track) return;
      var step = function () { var k = track.firstElementChild; return k ? k.offsetWidth + 20 : 300; };
      var prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      // drag to scroll
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.classList.add('is-dragging'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------------- Cart ---------------- */
  function toast(msg) {
    var t = document.querySelector('.s786-toast');
    if (!t) { t = document.createElement('div'); t.className = 's786-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  // Open the theme quick cart drawer (never navigate to /cart while it exists)
  function openDrawer() {
    var qc = document.querySelector('.quick-cart'); if (!qc) return false;
    var wrap = qc.querySelector('.quick-cart__wrapper') || qc;
    var isOpen = function () { return wrap.classList.contains('active'); };
    if (isOpen()) return true;
    var icons = document.querySelectorAll('[data-js-cart-icon]');
    for (var i = 0; i < icons.length && !isOpen(); i++) {
      var icon = icons[i], href = icon.getAttribute('href');
      icon.removeAttribute('href'); icon.dataset.s786Opening = '1';
      try { icon.click(); } catch (e) {}
      delete icon.dataset.s786Opening;
      if (href !== null) icon.setAttribute('href', href);
    }
    if (!isOpen()) {
      wrap.classList.add('active');
      document.body.setAttribute('data-fluorescent-overlay-open', 'true');
      qc.querySelectorAll('.quick-cart__item, .quick-cart__footer, .quick-cart__heading').forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; });
    }
    return true;
  }
  function openCart() {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    if (!document.querySelector('.quick-cart')) return;
    setTimeout(openDrawer, 500);
  }
  // Header cart icon: always open the drawer instead of the cart page
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('[data-js-cart-icon]'); if (!icon || icon.dataset.s786Opening) return;
    if (!document.querySelector('.quick-cart')) return; // no drawer -> let it go to /cart
    e.preventDefault(); e.stopPropagation();
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    setTimeout(openDrawer, 150);
  }, true);
  // Always release scroll when the quick cart closes (theme + Lenis can get stuck)
  function unlockScroll() {
    if (document.body.getAttribute('data-fluorescent-overlay-open') === 'true') document.body.setAttribute('data-fluorescent-overlay-open', 'false');
    document.body.classList.remove('scroll-lock', 'overflow-hidden');
    document.body.style.overflow = ''; document.body.style.position = ''; document.body.style.top = '';
    document.documentElement.style.overflow = ''; document.documentElement.classList.remove('lenis-stopped');
    if (window.lenis && typeof window.lenis.start === 'function') window.lenis.start();
  }
  function watchQuickCart() {
    var wrap = document.querySelector('.quick-cart__wrapper'); if (!wrap || wrap.dataset.s786Watch) return; wrap.dataset.s786Watch = '1';
    var was = wrap.classList.contains('active');
    new MutationObserver(function () {
      var now = wrap.classList.contains('active');
      if (was && !now) setTimeout(unlockScroll, 50);
      was = now;
    }).observe(wrap, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('click', function (e) { if (e.target.closest('.quick-cart__close-icon, .quick-cart__overlay')) setTimeout(unlockScroll, 400); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTimeout(unlockScroll, 400); });
  function qtyFor(btn) { var sel = btn.dataset.qtyFrom; var i = sel && document.querySelector(sel); var q = i ? parseInt(i.value, 10) : 1; return q > 0 ? q : 1; }
  // line item properties from a bundle picker in the same product section
  function propsFor(btn) {
    var sec = btn.closest('[data-pdp]') || document; var inp = sec.querySelector('[data-line-properties]');
    if (!inp || !inp.value) return {};
    try { return { properties: JSON.parse(inp.value) }; } catch (e) { return {}; }
  }
  function bundleReady(btn) {
    var sec = btn.closest('[data-pdp]') || document; var b = sec.querySelector('[data-bundle]');
    if (!b) return true;
    var need = parseInt(b.dataset.picks, 10) || 0, have = parseInt(b.dataset.have || '0', 10);
    if (have >= need) return true;
    toast('Please choose ' + (need - have) + ' more colour' + (need - have > 1 ? 's' : ''));
    if (g) g.fromTo(b, { x: -6 }, { x: 0, duration: 0.5, ease: 'elastic.out(1,0.3)' });
    b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }
  function addToCart(btn) {
    var id = btn.dataset.addToCart; if (!id || btn.classList.contains('is-loading')) return;
    if (!bundleReady(btn)) return;
    btn.classList.add('is-loading');
    var label = btn.querySelector('span') || btn; var old = label.textContent;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [Object.assign({ id: parseInt(id, 10), quantity: qtyFor(btn) }, propsFor(btn))] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading'); btn.classList.add('is-added'); label.textContent = 'Added ✓';
      setTimeout(function () { btn.classList.remove('is-added'); label.textContent = old; }, 2000);
      toast((res.items && res.items[0] ? res.items[0].product_title.split(' - ')[0] : 'Item') + ' added to your bag');
      openCart();
      if (g) g.fromTo(btn, { scale: 0.94 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1,0.5)' });
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      var msg = 'Could not add to cart';
      if (err && err.json) err.json().then(function (j) { toast(j.description || j.message || msg); }); else toast(msg);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-to-cart]'); if (b) { e.preventDefault(); addToCart(b); return; }
    var h = e.target.closest('[data-wishlist]');
    if (h) {
      e.preventDefault(); h.classList.toggle('is-on');
      try { var k = 's786_wish', l = JSON.parse(localStorage.getItem(k) || '[]'), i = l.indexOf(h.dataset.wishlist); i > -1 ? l.splice(i, 1) : l.push(h.dataset.wishlist); localStorage.setItem(k, JSON.stringify(l)); } catch (x) {}
      if (g) g.fromTo(h, { scale: 0.6 }, { scale: 1, duration: 0.7, ease: 'elastic.out(1,0.4)' });
    }
  });
  function restoreWishlist(root) {
    try { var l = JSON.parse(localStorage.getItem('s786_wish') || '[]'); root.querySelectorAll('[data-wishlist]').forEach(function (h) { h.classList.toggle('is-on', l.indexOf(h.dataset.wishlist) > -1); }); } catch (x) {}
  }

  /* ---------------- Floating collage ---------------- */
  function floaters(root) {
    if (!g || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('[data-anim-float]').forEach(function (el, i) {
      if (el.dataset.floatDone) return; el.dataset.floatDone = '1';
      g.to(el, { y: (i % 2 ? 10 : -12), rotation: (i % 2 ? 1.2 : -1.2), duration: 3 + i * 0.4, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: i * 0.3 });
    });
    // mouse parallax on collage
    root.querySelectorAll('.s786-spot__collage').forEach(function (col) {
      col.addEventListener('mousemove', function (e) {
        var r = col.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        col.querySelectorAll('.s786-spot__img').forEach(function (im, i) { g.to(im, { x: px * (10 + i * 6), yPercent: py * (4 + i * 2), duration: 0.8, ease: 'power2.out', overwrite: 'auto' }); });
      });
    });
  }

  /* ---------------- Product page ---------------- */
  function pdp(root) {
    var s = root.querySelector('[data-pdp]'); if (!s || s.dataset.pdpDone) return; s.dataset.pdpDone = '1';
    // gallery
    var slides = s.querySelectorAll('[data-slides] .s786-pdp__slide'), thumbs = s.querySelectorAll('[data-thumb]'), dots = s.querySelector('[data-dots]');
    var keys = Array.prototype.map.call(slides, function (x) { return x.dataset.slide; }), cur = 0;
    if (dots) keys.forEach(function () { dots.appendChild(document.createElement('i')); });
    function go(i) {
      if (!keys.length) return;
      cur = (i + keys.length) % keys.length; var k = keys[cur];
      slides.forEach(function (x) { x.classList.toggle('is-active', x.dataset.slide === k); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x.dataset.thumb === k); });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === cur); });
      var tag = s.querySelector('[data-3d-tag]'); if (tag) tag.style.opacity = k === '3d' ? 1 : 0;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(keys.indexOf(t.dataset.thumb)); }); });
    var pv = s.querySelector('[data-slide-prev]'), nx = s.querySelector('[data-slide-next]');
    pv && pv.addEventListener('click', function () { go(cur - 1); }); nx && nx.addEventListener('click', function () { go(cur + 1); });
    if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.addEventListener('click', function () { go(j); }); });
    var stage = s.querySelector('.s786-pdp__stage'), tx = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { if (keys[cur] === '3d') return; tx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(dx) > 40) go(dx < 0 ? cur + 1 : cur - 1); });
    }
    go(0);
    // shade colour for the 3D bottle when no hex given
    if (!s.dataset.shade && s.dataset.image) {
      loadShadeMap().then(function (map) {
        var handle = s.dataset.handle || (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
        var hex = handle && map[handle];
        var apply = function (c) { if (!c) return; s.querySelectorAll('[data-bottle-3d]').forEach(function (b) { b.dataset.color = c; if (b._bottle) b._bottle.setColor(c); }); };
        hex ? apply(hex) : colorFromImage(s.dataset.image).then(apply);
      });
    }
    // qty
    var qi = s.querySelector('[data-qty-input]');
    if (qi) {
      s.querySelectorAll('[data-qty-minus]').forEach(function (b) { b.addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); }); });
      s.querySelectorAll('[data-qty-plus]').forEach(function (b) { b.addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; }); });
    }
    // tabs
    var tb = s.querySelector('[data-pdp-tabs]');
    if (tb) tb.querySelectorAll('[data-tab]').forEach(function (t) { t.addEventListener('click', function () {
      tb.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active');
      tb.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === t.dataset.tab); }); moveTabLine(t);
    }); });
    // variants
    var vs = s.querySelector('[data-variants]');
    if (vs) {
      var variants = JSON.parse(vs.textContent), selects = s.querySelectorAll('[data-option-index]');
      var money = function (c) { var f = (window.S786 && window.S786.moneyFormat) || 'Rs {{amount}}'; return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })); };
      selects.forEach(function (sel) { sel.addEventListener('change', function () {
        var opts = Array.prototype.map.call(selects, function (x) { return x.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) return;
        s.querySelectorAll('[data-add-main], [data-add-sticky]').forEach(function (b) { b.dataset.addToCart = v.id; b.disabled = !v.available; var l = b.querySelector('span:last-child'); if (l) l.textContent = v.available ? 'Add to cart' : 'Sold out'; });
        var bn = s.querySelector('[data-buy-now]'); if (bn) bn.dataset.buyNow = v.id;
        s.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = money(v.price); });
        var swatch = v.option1 && /^#?[0-9a-f]{6}$/i.test(v.option1) ? v.option1 : null; if (swatch && window.S786Bottle) window.S786Bottle.setColor(swatch);
        try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
      }); });
    }
    // buy now
    s.addEventListener('click', function (e) {
      var b = e.target.closest('[data-buy-now]'); if (!b) return; e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.dataset.buyNow, 10), quantity: qtyFor(s.querySelector('[data-add-main]') || b) }] }) })
        .then(function () { location.href = '/checkout'; }).catch(function () { toast('Could not start checkout'); });
    });
    // zoom lens on photos
    if (stage && window.matchMedia('(hover: hover)').matches) {
      stage.addEventListener('click', function (e) { if (keys[cur] === '3d' || e.target.closest('button')) return; stage.classList.toggle('is-zoom'); });
      stage.addEventListener('mousemove', function (e) { var r = stage.getBoundingClientRect(); stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
    }
    // sticky bar
    var bar = s.querySelector('[data-sticky-bar]'), buy = s.querySelector('.s786-pdp__buy');
    if (bar && buy && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(buy);
  }

  /* ---------------- Full-screen menu ---------------- */
  function menu() {
    var m = document.querySelector('[data-s786-menu]'); if (!m) return;
    // The theme header uses transform (sticky), which traps position:fixed children. Move the panel to <body>.
    if (m.parentElement !== document.body) document.body.appendChild(m);
    if (m.dataset.done) return; m.dataset.done = '1';
    var toggles = function () { return document.querySelectorAll('[data-s786-menu-toggle]'); };
    var items = m.querySelectorAll('[data-s786-menu-item], .s786-menu__search, .s786-menu__bottom');
    function open() {
      m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.classList.add('s786-menu-open', 'scroll-lock');
      toggles().forEach(function (t) { t.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); });
      if (g) g.fromTo(items, { x: 40, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: 0.8, ease: 'power3.out', stagger: 0.06, delay: 0.25, overwrite: true });
    }
    function close() {
      m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.classList.remove('s786-menu-open', 'scroll-lock');
      toggles().forEach(function (t) { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); });
    }
    document.addEventListener('click', function (e) { var t = e.target.closest('[data-s786-menu-toggle]'); if (!t) return; e.preventDefault(); e.stopPropagation(); m.classList.contains('is-open') ? close() : open(); }, true);
    m.querySelectorAll('[data-s786-menu-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    m.querySelectorAll('[data-s786-sub-toggle]').forEach(function (b) { b.addEventListener('click', function () {
      var li = b.closest('.s786-menu__item'), on = li.classList.toggle('is-open'); b.setAttribute('aria-expanded', on);
      m.querySelectorAll('.s786-menu__item.is-open').forEach(function (o) { if (o !== li) { o.classList.remove('is-open'); var ob = o.querySelector('[data-s786-sub-toggle]'); if (ob) ob.setAttribute('aria-expanded', 'false'); } });
    }); });
    m.querySelectorAll('a[href]').forEach(function (a) { a.addEventListener('click', function () { setTimeout(close, 150); }); });
  }

  /* ---------------- Collection filters + sort ---------------- */
  function collection(root) {
    var c = root.querySelector('[data-collection]'); if (!c || c.dataset.done) return; c.dataset.done = '1';
    var items = c.querySelectorAll('.s786-coll__item');
    c.querySelectorAll('[data-coll-tabs] [data-tab]').forEach(function (t) { t.addEventListener('click', function () {
      c.querySelectorAll('[data-coll-tabs] [data-tab]').forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active'); moveTabLine(t);
      var tags = (t.dataset.tags || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean), shown = [];
      items.forEach(function (it) { var mine = (it.dataset.tags || '').split(','); var ok = !tags.length || tags.some(function (tg) { return mine.indexOf(tg) > -1; }); it.classList.toggle('is-hidden', !ok); if (ok) shown.push(it); });
      if (g) g.fromTo(shown, { y: 24, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.6, ease: 'power3.out', stagger: 0.04, overwrite: true });
      var empty = c.querySelector('.s786-coll__empty'); if (!shown.length && !empty) { var p = document.createElement('p'); p.className = 's786-coll__empty'; p.textContent = 'No products in this group on this page.'; c.querySelector('[data-coll-grid]').appendChild(p); } else if (shown.length && empty && items.length) empty.remove();
    }); });
    var sort = c.querySelector('[data-coll-sort]');
    if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  }

  /* ---------------- Cart page (AJAX) ---------------- */
  function cartPage(root) {
    var c = root.querySelector('[data-cart]'); if (!c || c.dataset.done) return; c.dataset.done = '1';
    var sectionId = c.dataset.section, busy = false;
    function rerender() {
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart?section_id=' + sectionId).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html; var fresh = d.querySelector('[data-cart]');
        if (fresh) { fresh.dataset.done = '1'; c.replaceWith(fresh); c = fresh; bind(); }
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        if (window.Motion) window.Motion.scan(c);
      });
    }
    function change(key, qty) {
      if (busy) return; busy = true; var row = c.querySelector('[data-cart-item][data-key="' + key + '"]'); if (row && qty === 0) row.classList.add('is-removing');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function () { busy = false; return rerender(); }).catch(function () { busy = false; toast('Could not update the bag'); });
    }
    function bind() {
      c.querySelectorAll('[data-cart-item]').forEach(function (row) {
        var key = row.dataset.key, input = row.querySelector('[data-cart-qty]');
        row.querySelector('[data-cart-minus]').addEventListener('click', function () { change(key, Math.max(0, (parseInt(input.value, 10) || 1) - 1)); });
        row.querySelector('[data-cart-plus]').addEventListener('click', function () { change(key, (parseInt(input.value, 10) || 0) + 1); });
        input.addEventListener('change', function () { change(key, Math.max(0, parseInt(input.value, 10) || 0)); });
        row.querySelector('[data-cart-remove]').addEventListener('click', function () { change(key, 0); });
      });
      var note = c.querySelector('[data-cart-note]'); if (note) note.addEventListener('change', function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); });
      var co = c.querySelector('[data-cart-checkout]'); if (co) co.addEventListener('click', function () { location.href = '/checkout'; });
    }
    bind();
  }

  // Remove the Instafeed app widget (script-tag app, cannot be disabled from theme settings)
  function removeInstafeed() {
    var kill = function () { document.querySelectorAll('#instafeed, .instafeed, .ifs-title-container, [id^="instafeed"], [class^="ifs-"]').forEach(function (el) { el.remove(); }); };
    kill(); new MutationObserver(kill).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- Bundle picker (choose N colours) ---------------- */
  function bundle(root) {
    root.querySelectorAll('[data-bundle]').forEach(function (b) {
      if (b.dataset.done) return; b.dataset.done = '1';
      var need = parseInt(b.dataset.picks, 10) || 4, picked = [];
      var slots = b.querySelectorAll('[data-slot]'), remaining = b.querySelector('[data-bundle-remaining]');
      var sec = b.closest('[data-pdp]') || document, propInput = sec.querySelector('[data-line-properties]');
      var addBtns = function () { return sec.querySelectorAll('[data-add-main], [data-add-sticky]'); };
      function render() {
        slots.forEach(function (s, i) {
          var it = picked[i];
          s.style.backgroundImage = it && it.img ? 'url(' + it.img + ')' : 'none';
          s.style.backgroundColor = it && !it.img && it.hex ? it.hex : 'transparent';
          s.classList.toggle('is-filled', !!it); s.title = it ? it.name : '';
        });
        var left = need - picked.length; if (remaining) remaining.textContent = left;
        b.dataset.have = picked.length; b.classList.toggle('is-complete', left === 0);
        b.querySelectorAll('[data-bundle-item]').forEach(function (it) {
          var n = picked.filter(function (x) { return x.name === it.dataset.name; }).length;
          it.querySelectorAll('[data-bundle-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
          it.classList.toggle('is-selected', n > 0);
          it.classList.toggle('is-maxed', left === 0 && n === 0);
        });
        var names = picked.map(function (x) { return x.name; });
        if (propInput) propInput.value = names.length ? JSON.stringify({ 'Selected Colors': names.join(', ') }) : '';
        addBtns().forEach(function (a) { a.classList.toggle('is-waiting', left > 0); var l = a.querySelector('.s786-btn__label, span:last-child'); if (l && !a.dataset.origLabel) a.dataset.origLabel = l.textContent; if (l) l.textContent = left > 0 ? 'Choose ' + left + ' more' : a.dataset.origLabel; });
      }
      b.addEventListener('click', function (e) {
        var plus = e.target.closest('[data-bundle-plus]'), minus = e.target.closest('[data-bundle-minus]'); if (!plus && !minus) return;
        e.preventDefault();
        var it = e.target.closest('[data-bundle-item]'); if (!it) return;
        var name = it.dataset.name, img = it.querySelector('img'), hex = it.dataset.hex;
        if (plus) { if (picked.length >= need) { toast('You already picked ' + need + ' colours'); return; } picked.push({ name: name, img: img ? img.currentSrc || img.src : '', hex: hex }); if (g) g.fromTo(it, { scale: 0.9 }, { scale: 1, duration: 0.5, ease: 'elastic.out(1,0.4)' }); }
        else { var i = picked.map(function (x) { return x.name; }).lastIndexOf(name); if (i > -1) picked.splice(i, 1); }
        render();
      });
      // slider arrows
      var grid = b.querySelector('[data-bundle-grid]');
      var step = function () { var it = grid && grid.querySelector('[data-bundle-item]'); return it ? (it.offsetWidth + 8) * 3 : 260; };
      var pv = b.querySelector('[data-bundle-prev]'), nx = b.querySelector('[data-bundle-next]');
      if (pv && grid) pv.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nx && grid) nx.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
      // clicking a filled slot removes that pick
      slots.forEach(function (s, i) { s.addEventListener('click', function () { if (picked[i]) { picked.splice(i, 1); render(); } }); });
      render();
    });
  }

  /* ---------------- Description: 3 lines + Read more ---------------- */
  function readMore(root) {
    root.querySelectorAll('.s786-pdp__panel[data-panel="desc"]').forEach(function (panel) {
      if (panel.dataset.rm) return; panel.dataset.rm = '1';
      var rte = panel.querySelector('.rte'); if (!rte) return;
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 's786-pdp__more'; btn.textContent = 'Read more …';
      panel.appendChild(btn);
      function check() { panel.classList.remove('is-expanded'); var clamped = rte.scrollHeight > rte.clientHeight + 2; panel.classList.toggle('is-clampable', clamped); }
      btn.addEventListener('click', function () { var open = panel.classList.toggle('is-expanded'); btn.textContent = open ? 'Show less' : 'Read more …'; });
      check(); window.addEventListener('resize', function () { if (!panel.classList.contains('is-expanded')) check(); });
      setTimeout(check, 600);
    });
  }

  /* ---------------- Quick search: always side drawer, never navigate; close always works ---------------- */
  (function () {
    var qs = document.querySelector('[data-quick-search], #MainQuickSearch');
    document.querySelectorAll('[data-search], .header__icon-touch--search').forEach(function (a) { a.removeAttribute('href'); });
    if (!qs) return;
    var closing = false;
    function closeIt() {
      if (!qs.classList.contains('active') || closing) return; closing = true;
      qs.classList.remove('quick-search--visible');
      setTimeout(function () {
        qs.classList.remove('active'); qs.setAttribute('aria-hidden', 'true');
        document.body.setAttribute('quick-search-open', 'false');
        unlockScroll(); closing = false;
      }, 350);
    }
    function openIt() {
      if (qs.classList.contains('active')) return;
      qs.classList.add('active'); qs.setAttribute('aria-hidden', 'false');
      document.body.setAttribute('quick-search-open', 'true');
      document.body.setAttribute('data-fluorescent-overlay-open', 'true');
      setTimeout(function () {
        qs.classList.add('quick-search--visible');
        var inp = qs.querySelector('[data-input], input[type="search"], input[name="q"]'); if (inp) inp.focus({ preventScroll: true });
      }, 50);
    }
    // open from header icon
    document.addEventListener('click', function (e) {
      var icon = e.target.closest('[data-search], .header__icon-touch--search'); if (!icon) return;
      icon.removeAttribute('href'); e.preventDefault();
      setTimeout(openIt, 120); // let the theme open it first if it can
    }, false);
    // close: X button, overlay, Escape — bound once, work whoever opened it
    document.addEventListener('click', function (e) {
      if (!qs.classList.contains('active')) return;
      if (e.target.closest('#MainQuickSearch [data-close-icon], #MainQuickSearch .quick-search__close, #MainQuickSearch [data-overlay], #MainQuickSearch .quick-search__overlay')) { e.preventDefault(); closeIt(); }
    }, true);
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeIt(); });
    // theme closed it on its own -> make sure scroll is unlocked
    new MutationObserver(function () { if (!qs.classList.contains('active') && document.body.getAttribute('quick-search-open') === 'true') { document.body.setAttribute('quick-search-open', 'false'); unlockScroll(); } }).observe(qs, { attributes: true, attributeFilter: ['class'] });
  })();

  function init(root) {
    root = root || document;
    shadeWall(root); tabs(root); carousel(root); floaters(root); restoreWishlist(root); pdp(root); menu(); collection(root); cartPage(root); watchQuickCart(); bundle(root); readMore(root); removeInstafeed();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { init(); }) : init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); var nm = e.target.querySelector && e.target.querySelector('[data-s786-menu]'); var om = document.body.querySelector(':scope > [data-s786-menu]'); if (nm && om && nm !== om) { om.remove(); } menu(); });
  window.S786 = Object.assign(window.S786 || {}, { init: init, toast: toast, addToCart: addToCart });
})();
